import { useEffect, useState } from "react";
import "./style.css";

export default function IncomingCallModal({ call, caller, onAnswer, onDecline }) {
  const [callDuration, setCallDuration] = useState(0);

  useEffect(() => {
    console.log("📞 IncomingCallModal mounted:", { call, caller });
    
    // Start call duration timer
    const timer = setInterval(() => {
      setCallDuration(prev => prev + 1);
    }, 1000);

    // Auto-decline after 30 seconds
    const autoDeclineTimer = setTimeout(() => {
      console.log("📞 Auto-declining call after 30 seconds");
      onDecline();
    }, 30000);

    return () => {
      console.log("📞 IncomingCallModal unmounting");
      clearInterval(timer);
      clearTimeout(autoDeclineTimer);
    };
  }, [onDecline, call, caller]);

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const callTypeText = call.type === 'video' ? 'Video Call' : 'Voice Call';
  const callIcon = call.type === 'video' ? '📹' : '📞';

  console.log("📞 Rendering IncomingCallModal:", { 
    callId: call._id, 
    callerName: `${caller.first_name} ${caller.last_name}`,
    callType: call.type,
    duration: callDuration
  });

  return (
    <div className="incoming_call_overlay">
      <div className="incoming_call_modal">
        {/* Caller Info */}
        <div className="caller_info">
          <div className="caller_avatar_container">
            <img
              src={caller.picture}
              alt={caller.first_name}
              className="caller_avatar"
              onError={(e) => {
                console.log("📞 Avatar image failed to load, using default");
                e.target.src = '/images/default_profile.png';
              }}
            />
            <div className="call_type_indicator">
              <span className="call_icon">{callIcon}</span>
            </div>
          </div>
          
          <div className="caller_details">
            <h3 className="caller_name">
              {caller.first_name} {caller.last_name}
            </h3>
            <p className="call_type">{callTypeText}</p>
            <p className="call_duration">{formatDuration(callDuration)}</p>
            <p className="call_status">Incoming call...</p>
          </div>
        </div>

        {/* Animated Background */}
        <div className="call_animation">
          <div className="pulse_ring"></div>
          <div className="pulse_ring pulse_ring_2"></div>
          <div className="pulse_ring pulse_ring_3"></div>
        </div>

        {/* WhatsApp-style slide to answer hint */}
        <div className="slide_to_answer">
          Slide to answer
        </div>

        {/* Call Actions */}
        <div className="call_actions">
          <button
            className="call_action_btn decline_btn"
            onClick={() => {
              console.log("📞 Call declined by user");
              onDecline();
            }}
            title="Decline call"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6.4 19L5 17.6l5.6-5.6L5 6.4 6.4 5l5.6 5.6L17.6 5 19 6.4 13.4 12l5.6 5.6-1.4 1.4-5.6-5.6z"/>
            </svg>
          </button>
          
          <button
            className="call_action_btn answer_btn"
            onClick={() => {
              console.log("📞 Call answered by user");
              onAnswer();
            }}
            title="Answer call"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
            </svg>
          </button>
        </div>

        {/* Quick Actions */}
        <div className="quick_actions">
          <button className="quick_action_btn" title="Mute">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
            </svg>
          </button>
          
          <button className="quick_action_btn" title="Send message">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
} 